/**
 * Returns a debounced version of fn that delays invoking it until after
 * `delay` ms have elapsed since the last call.
 * Supports .cancel() to abort a pending invocation.
 *
 * @param {Function} fn
 * @param {number} delay - milliseconds
 * @returns {Function}
 */
export default function debounce(fn, delay) {
  let timer;
  function debounced(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  }
  debounced.cancel = () => clearTimeout(timer);
  return debounced;
}
